import { render, staticRenderFns } from "./Reviewcards.vue?vue&type=template&id=6fcd818d&scoped=true&"
import script from "./Reviewcards.vue?vue&type=script&lang=js&"
export * from "./Reviewcards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcd818d",
  null
  
)

export default component.exports